



















import { Component } from "vue-property-decorator";
import Dialog from "@/components/Dialog.vue";
import ErrorList from "@/components/ErrorList.vue";
import HacoCommon from "../HacoCommon";
import PaperSizeComp from "@/components/PaperSizeComp.vue";

@Component({
  name: "PaperSize",
  components: {
    PaperSizeComp,
    Dialog,
    ErrorList
  }
})
export default class PaperSize extends HacoCommon {
  // put something
}
